import { render, staticRenderFns } from "./ManageCommittees.vue?vue&type=template&id=0dc85a20&scoped=true"
import script from "./ManageCommittees.vue?vue&type=script&lang=js"
export * from "./ManageCommittees.vue?vue&type=script&lang=js"
import style0 from "./ManageCommittees.vue?vue&type=style&index=0&id=0dc85a20&prod&lang=css"
import style1 from "./ManageCommittees.vue?vue&type=style&index=1&id=0dc85a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc85a20",
  null
  
)

export default component.exports